window.onload = function () {

  // Accordions
  const accordionItemHeaders = document.querySelectorAll(".accordion__header");
  if (accordionItemHeaders) {
    const accordionItemContents = document.querySelectorAll(".accordion__content");
    let maxHeight = 0;

    // Loop through the contents and find the tallest one
    accordionItemContents.forEach(content => {
      const contentHeight = content.offsetHeight;
      if (contentHeight > maxHeight) {
        maxHeight = contentHeight;
      }
    });
    accordionItemHeaders.forEach(accordionItemHeader => {
      accordionItemHeader.addEventListener("click", event => {
        accordionItemHeaders.forEach(header => header.classList.remove('active'));
        accordionItemHeader.classList.add('active');
        const accordionContent = accordionItemHeader.nextElementSibling;
        console.log(accordionContent, maxHeight);
        accordionContent.style.height = maxHeight + 'px';
      });
    });
  }

  // Featured projects
  
  var projectCarousel = document.querySelector('.project-carousel');
  if (projectCarousel) {
    var projectSlider = new Flickity( projectCarousel, {
      cellAlign: 'center',
      imagesLoaded: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true
    });
  }
   document.addEventListener('click', function(event) {
      const target = event.target;
      if (target.hasAttribute('data-badge-filter')) {
        const badgeValue = target.getAttribute('data-badge-filter');
        console.log('Data badge filter value:', badgeValue);
  
        const allBadges = document.querySelectorAll('[data-badge-filter]');
        allBadges.forEach(badge => badge.classList.remove('selected'));
        target.classList.add('selected');
        
        const projectItems = document.querySelectorAll('[data-item-filters]');
        projectItems.forEach(item => {
            const itemFilters = item.getAttribute('data-item-filters');
  
            if (badgeValue == 'all') {
              item.style.display = '';
            } else {
              // Check if the badgeValue is NOT in the itemFilters list
              if (!itemFilters.split(',').map(filter => filter.trim()).includes(badgeValue)) {
                  // Hide the element if the badgeValue is not found
                  item.style.display = 'none';
              } else {
                  // Show the element if the badgeValue is found
                  item.style.display = '';
              }
            }
        });
      }
    });
  
};